(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutCreditBalanceController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {

            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'CreditBalance';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.AccountTypeData = {};

            $scope.Control.SetCreditBalanceSuccess = false;
            $scope.Control.AmountSubmitted = false;
            $scope.Control.AmountCleared = false;
            $scope.Control.AmountRequired = false;
            $scope.Control.AmountInvalid = false;
            $scope.Control.NoAvailablePoints = false;
            $scope.Control.PointsAlreadyApplied = false;
            $scope.Control.ClearButtonVisible = false;

            $scope.Control.Amount = '';
            $scope.Control.CreditBalance = '';
            $scope.Control.CreditBalanceInMoney = '';
            $scope.Control.PointsApplied = 0;
            $scope.Control.PointsAppliedInMoney = '';
            $scope.Control.ResultMessage = '';

            $scope.Control.setCreditBalance = function () {
                $scope.Control.Loading = true;

                if ($scope.Model.Data.AccountTypeConfiguration.IsPartialRedemptionAllowed) {
                    if (!$scope.Control.Amount || $scope.Control.Amount.trim() == '') {
                        $scope.Control.AmountRequired = true;
                        return;
                    }
                } else {
                    $scope.Control.Amount = $scope.Control.CreditBalance;
                }

                $scope.Control.AmountRequired = false;

                ControlService.invokeCheckout($scope, $element, 'SetCreditBalance', $scope.Control.Amount).then(function (response) {
                    var response = jQuery.parseJSON(response);
                    response.data = jQuery.parseJSON(response.Data);

                    $scope.Control.AmountSubmitted = true;
                    $scope.Control.Success = response.Success;
                    $scope.Control.ResultMessage = response.data.Message;

                    if ($scope.Control.Success) {
                        $scope.Control.SetCreditBalanceSuccess = true;
                        $scope.Control.ClearButtonVisible = true;
                        $scope.Control.PointsApplied = response.data.PointsApplied;
                        $scope.Control.PointsAppliedInMoney = response.data.PointsInMoneyApplied;

                        $scope.Order.Wrapper.reload().then(function () {
                            $scope.Control.Loading = false;
                        }, function (error) {
                            $scope.Control.Loading = false;
                            throw error;
                        });
                    } else {
                        $scope.Control.SetCreditBalanceSuccess = false;
                        $scope.Control.CurrentBalance = '';
                        $scope.Control.PointsApplied = '';
                        $scope.Control.PointsAppliedInMoney = '';
                    }

                    $scope.Control.Loading = false;

                }, function (ex) {
                    console.log(ex);
                    $scope.Control.IsValid = false;
                    $scope.Control.Loading = false;

                    $scope.Control.Result = 'CreditBalance_ServiceError';
                    $scope.Control.ResultMessage = 'Generic error. Please try again later.';

                    $scope.$apply();
                });
            };

            $scope.Control.clearCreditBalance = function () {
                ControlService.invokeCheckout($scope, $element, 'ClearCreditBalance').then(function (response) {
                    var response = jQuery.parseJSON(response);
                    response.data = jQuery.parseJSON(response.Data);

                    $scope.Control.Success = response.Success;
                    $scope.Control.ResultMessage = response.data.Message;

                    if ($scope.Control.Success) {
                        $scope.Control.SetCreditBalanceSuccess = false;
                        $scope.Control.PointsAlreadyApplied = false;
                        $scope.Control.ClearButtonVisible = false;
                        $scope.Control.AmountSubmitted = false;
                        $scope.Control.AmountCleared = true;

                        $scope.Control.Amount = '';
                        $scope.Control.PointsApplied = response.data.PointsApplied;
                        $scope.Control.PointsAppliedInMoney = response.data.PointsInMoneyApplied;
                        
                        $scope.Order.Wrapper.reload().then(function () {
                            $scope.Control.Loading = false;
                        }, function (error) {
                            $scope.Control.Loading = false;
                            throw error;
                        });

                    } else {
                        $scope.Control.AmountCleared = false;
                    }

                    $scope.Control.Loading = false;

                }, function (ex) {
                    console.log(ex);
                    $scope.Control.IsValid = false;
                    $scope.Control.Loading = false;

                    $scope.Control.Result = 'CreditBalance_ServiceError';
                    $scope.Control.ResultMessage = 'Generic error. Please try again later.';

                    $scope.$apply();
                });
            };

            ControlService.getCheckoutData("GetCreditBalance", $scope, $element).then(function (response) {
                $scope.Model = {};

                $scope.Control.CreditBalance= response.Data.TotalCreditBalance;
                $scope.Control.CreditBalanceInMoney = response.Data.TotalCreditBalanceInMoney;
                $scope.Control.PointsApplied = response.Data.PointsApplied;
                $scope.Control.PointsAppliedInMoney = response.Data.PointsAppliedInMoney;
                $scope.Control.PointsLeft = response.Data.PointsLeft;

                if ($scope.Control.PointsApplied > 0) {
                    $scope.Control.PointsAlreadyApplied = true;
                    $scope.Control.ClearButtonVisible = true;
                }

                if ($scope.Control.CreditBalance <= 0 && $scope.Control.PointsApplied <= 0)
                    $scope.Control.NoAvailablePoints = true;

                angular.extend($scope.Model, response);

                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

            ControlService.getCheckoutData("GetCreditBalanceAccountType", $scope, $element).then(function (response) {
                $scope.Model = $scope.Model ? $scope.Model : {};
                $scope.Control.AccountTypeData = response;

                angular.extend($scope.Model.Data, response.Data);

                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

        });
})();